/**
 * @file: formatTrialEnd.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import dayjs from 'dayjs';

/** `试用至 10月30日`, the year only when it is not this one. */
export function formatTrialEnd(trialEndsAt: string): string {
  const end = dayjs(trialEndsAt);
  const format = end.year() === dayjs().year() ? 'M月D日' : 'YYYY年M月D日';
  return `试用至 ${end.format(format)}`;
}
